"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GCCDomainPatterns = [
    "gov.omnichannelengagementhub.us",
    "-crm9"
];
exports.default = GCCDomainPatterns;
//# sourceMappingURL=GCCDomainPatterns.js.map